import api from './api';

type ApiEnvelope<T> = {
  success: boolean;
  data: T;
  message?: string;
};

function unwrapData<T>(response: any, fallback: T): T {
  const payload = response?.data ?? response ?? fallback;
  return payload === null || payload === undefined ? fallback : (payload as T);
}

function envelope<T>(response: any, fallback: T): ApiEnvelope<T> {
  return {
    success: response?.success !== false,
    data: unwrapData(response, fallback),
    message: response?.message,
  };
}

export async function listAssets(projectId: string) {
  const response = await api.get<{ success: boolean; data: any[] }>(`/juben/assets`, { project_id: projectId });
  const data = unwrapData(response, []);
  return envelope(response, Array.isArray(data) ? data : []);
}

export async function createAsset(payload: {
  project_id: string;
  artifact_id?: string;
  name: string;
  asset_type?: string;
  tags?: string[];
  collection?: string;
  source?: string;
  metadata?: Record<string, any>;
}) {
  const response = await api.post<{ success: boolean; data: any }>(`/juben/assets`, payload);
  return envelope(response, {});
}

export async function updateAsset(projectId: string, assetId: string, payload: Record<string, any>) {
  const response = await api.put<{ success: boolean; data: any }>(`/juben/assets/${assetId}`, payload, { project_id: projectId });
  return envelope(response, { id: assetId, asset_id: assetId, degraded: true, ...payload });
}

export async function deleteAsset(projectId: string, assetId: string) {
  const response = await api.delete<{ success: boolean }>(`/juben/assets/${assetId}`, { project_id: projectId });
  return {
    success: response?.success !== false,
    message: (response as any)?.message,
  };
}

export async function listAssetCollections(projectId: string) {
  const response = await api.get<{ success: boolean; data: Record<string, any[]> }>(`/juben/assets/collections`, { project_id: projectId });
  const data = unwrapData(response, {});
  return envelope(response, data && typeof data === 'object' && !Array.isArray(data) ? data : {});
}
